import { up, down } from 'slide-element';
import announcer from './aria-announcer';

document.addEventListener('DOMContentLoaded', () => {
    const $mobileNavTrigger = document.querySelector('.mobile-nav-trigger');
    const $mobileMenu = document.querySelector('.mobile-menu');

    if ($mobileNavTrigger && $mobileMenu) {
        $mobileNavTrigger.addEventListener('click', () => {
            const isExpanded = $mobileNavTrigger.getAttribute('aria-expanded') === 'true';
            const newState = !isExpanded;

            $mobileNavTrigger.setAttribute('aria-expanded', String(newState));
            document.body.classList.toggle('mobile-menu-is-open', newState);

            if (newState) {
                const $searchBlock = document.querySelector('.block-search');
                if ($searchBlock && $searchBlock.classList.contains('is-open')) {
                    document.querySelectorAll('.btn-search-toggle').forEach((btn) => {
                        btn.setAttribute('aria-expanded', 'false');
                        btn.classList.remove('is-open');
                    });
                    $searchBlock.classList.remove('is-open');
                    up($searchBlock);
                }

                down($mobileMenu);
                announcer.announce('Le menu est ouvert');
            } else {
                up($mobileMenu);
                announcer.announce('Le menu est fermé');
            }
        });
    }
});
